import React, { Component } from 'react';
import './index.css';

class Porthole extends Component {
  render() {
    return <div className="portholeContainer">
  <div className="porthole portholeRubberDuckyVisible">
    <div className="portholeFill"></div>
  </div>
</div>
  }
}

export default Porthole;



// WEBPACK FOOTER //
// ./src/components/Porthole/index.js